import { generateBootstrap } from '@pegasus/sentry';
import { Config } from 'src/config/types';

export const isSentryEnabled = (config: Config) => config.enable?.sentry;

export const renderSentry = (config: Config): string => {
    return isSentryEnabled(config)
        ? generateBootstrap({
              config: { dsn: config.services.sentry },
              extras: {
                  appdomain: config.locale,
                  environment: config.environment,
              },
          })
        : '';
};
